module.exports = {"540525100":"曲松镇","540525101":"罗布沙镇","540525200":"下江乡","540525201":"邱多江乡","540525202":"堆随乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540525.json
// module id = 2728
// module chunks = 0